module.exports = __webpack_public_path__ + "static/media/adfa.cdaaad69.png";